/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
import { 
    // 取得帳號資訊
    apiBizGetUserInfo,
} from "@/apis/api.js"; 
import router from '@/router'

const types = {
    set_account_type: 'accountType/set_account_type',
}

// count state 必須是 Object
const state = {
    accountType: null,
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_ACCOUNT_TYPE: (state) => {
        return state.accountType
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getAccountType ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetUserInfo()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_account_type, res.data.result.memberType)
                    resolve(res.data.result.memberType)
                }
            })
            .catch(err => {
            })
        })
    },
    autoRedirect ( {commit, dispatch, getters}, data) {
        return new Promise((resolve, reject) => {
            if(localStorage.getItem('token')){
                dispatch('getAccountType')
                .then( res =>{
                  let type = res
                // console.log('type',type)
                // console.log('system',getters.GET_DEVICE_SYSTEM)
                  if(type === 'company'){
                    //   console.log('comany')
                    if(getters.GET_DEVICE_SYSTEM === 'pc'){
                    //   console.log('pcc')
                      router.push({name: 'bizHomeDefault'})
                    }else{
                        // router.push({name: 'myHome'})
                    //   console.log('mbb')
                      window.location = "/mb/enterprise/"
                    }
                  }else if(type === 'landlord'){
                    router.push({name: 'housestatusdefault'})
                    
                  }
                  console.log(res)
                })
            }
        })
    }
}

// mutations
const mutations = {
    [types.set_account_type](state, data){
        state.accountType = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global/accountType.js